$ = require 'jquery'
_ = require 'underscore'
log = require 'debug/log'
rpc = require 'network/rpc'
templates = require 'views/internal/templates'
l = require 'lib/localize'

# The Alerts class provides an interface for displaying alerts in the upper-right-hand corner of the Trello UI
# Each alert will have
# - A message to display for the user
# - A displayType string (info, confirm, warning, error)
# - An area string. Areas do not interfere with each others' alerts.
# - Optionally, an amount of time to persist before clearing
# Setting a new alert in a given area will clear old alerts in that area.
# Calling 'hide' will hide alerts in the specified area only
# Calling 'hideAll' will hide all alerts - never call this unless you're about
# to reload the page.

module.exports = new class

  _alerts: {}

  _hide: (area) ->
    alert = @_alerts[area]
    if alert?.timeout
      clearTimeout(alert.timeout)
    delete @_alerts[area]
    $("#notification_#{area}").remove()
    @_showHideContainer()

  _show: (msg, fHtml, displayType, area, msTimeout) ->
    log('alerts', "show", msg, fHtml, displayType, area, msTimeout)
    @_hide(area)
    if msTimeout
      timeout = setTimeout (=> @hide(area)), msTimeout
    @_alerts[area] = { timeout }
    $div = $('<div>')
      .attr('id', "notification_#{area}")
      .addClass("app-alert-item mod-#{displayType}")
      .appendTo('#notification')
    if fHtml
      $div.html(msg)
    else
      $div.text(msg)
    @_showHideContainer()

  _showHideContainer: ->
    $('#notification').toggle(!_.isEmpty(@_alerts))

  show: (key, args...) ->
    if Array.isArray(key)
      [key, data] = key
    else
      data = {}
    @showLiteralText l(['alerts', key], data), args...

  showLiteralText: (text, displayType, area, msTimeout) ->
    @_show text, false, displayType, area, msTimeout

  showHtml: (msgHtml, displayType, area, msTimeout) ->
    @_show msgHtml, true, displayType, area, msTimeout

  flash: (key, displayType, area) ->
    @show key, displayType, area, 2000

  hide: (area) ->
    log('alerts', "hide", area)
    @_hide(area)

  hideAll: ->
    @hide(area) for area of @_alerts


  # If you want to hook alerts up to your event emitter rather than calling
  # Alerts, you may do it here in the constructor for convenience
  constructor: ->

    # RPC event section
    showConnectingTimeout = null

    showConnectFailed = =>
      clearTimeout(showConnectingTimeout)
      @hide('connection')
      #Different area for connection dead to make it immune to race conditions
      msg = l('alerts.could not connect')
      @showHtml(templates.fill('connect_failed', { msg }), 'error', 'connectionDead')

    rpc.on 'connect_failed', showConnectFailed
    rpc.on 'reconnect_failed', showConnectFailed

    fxReconn = =>
      clearTimeout(showConnectingTimeout)
      @hide('connection')
      @hide('connectionDead')

    fxConn = =>
      # Only show the "Connecting" alert if we've been disconnected for more
      # than 500ms. This should cut down on it flashing really briefly when you
      # have a flaky internet connection.
      clearTimeout(showConnectingTimeout)
      showConnectingTimeout = setTimeout =>
        showConnectingTimeout = null
        @show('reconnecting', 'error', 'connection')
      , 500

    rpc.on 'reconnect', fxReconn
    rpc.on 'connecting', fxConn

    # End RPC event section



// WEBPACK FOOTER //
// ./app/scripts/views/lib/alerts.coffee